import { Box, Flex, Heading } from '@chakra-ui/react';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import IsDesktop from '../../utils/IsDesktop';
import ViewExpertDetails from '../experts/ViewExpertDetails';
import ViewFounderDetails from '../Founders/ViewFounderDetails';
import ViewInvestorDetails from '../investors/ViewInvestorDetails';
import SearchBar from '../searchbar/SearchBar';

const ViewSingleUser = ({ isPublic = false }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams({});
  const userid = searchParams.get('userid');
  const cid = searchParams.get('cid');
  const usertype = searchParams.get('usertype');

  const getUserType = (userTypeId) => {
    switch (userTypeId) {
      case '1':
        return 'Founder';
      case '2':
        return 'Investor';
      case '3':
        return 'Expert';
      default:
        break;
    }
  };

  const goBack = () => {
    window.scrollTo(0, 0);
    navigate(-1);
  };

  return (
    <Flex className="w-[100%] flex-col overflow-hidden p-3">
      {usertype === '1' && (
        <ViewFounderDetails
          isPublic={isPublic}
          founder={userid}
          companyId={cid || null}
          onToggle={goBack}
        />
      )}
      {usertype === '2' && (
        <ViewInvestorDetails
          isPublic={isPublic}
          investor={userid}
          onToggle={goBack}
        />
      )}
      {usertype === '3' && (
        <ViewExpertDetails
          isPublic={isPublic}
          expert={userid}
          onToggle={goBack}
        />
      )}
    </Flex>
  );
};
export default ViewSingleUser;
